/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddEmergencyContactAuthIdsRequest,
  AddEmergencyEmailRequest,
  AddGroupEmergencyContactAuthIdsRequest,
  AddGroupEmergencyEmailRequest,
  GetAllOrgResponse,
  GroupEmergencyContactsOnAzure,
  MiniOrganization,
  OrgEmergencyContactsOnAzure,
  OrgUserOnAzure,
  OrganizationAdminAddGroup,
  OrganizationAdminMoveGroupMemberRequest,
  OrganizationAdminRemoveGroup,
  OrganizationAdminUpdate,
  OrganizationAdminUpdateGroupLocationTracking,
  OrganizationAdminUpdateGroupName,
  OrganizationOnAzure,
  OrganizationSalesCreate,
  OrganizationSalesDelete,
  OrganizationSalesRequestUpdateSubscription,
  OrganizationSalesSeatReductionPreviewResponse,
  OrganizationSalesUpdate,
  OrganizationSalesUpdateSubscription,
  RemoveEmergencyContactAuthIdsRequest,
  RemoveEmergencyEmailRequest,
  RemoveGroupEmergencyContactAuthIdsRequest,
  RemoveGroupEmergencyEmailRequest,
  SendTestEmailRequest,
  SetRequireJoinApprovalRequest,
  SetRequireJoinApprovalResult,
  SetUserTierRequest,
  UpdateEmergencyEmailLanguageRequest,
  UpdateGroupEmergencyEmailLanguageRequest,
  UserCapabilitiesResponse,
  UserEmergencyContactResponse,
} from '../models/index';
import {
    AddEmergencyContactAuthIdsRequestFromJSON,
    AddEmergencyContactAuthIdsRequestToJSON,
    AddEmergencyEmailRequestFromJSON,
    AddEmergencyEmailRequestToJSON,
    AddGroupEmergencyContactAuthIdsRequestFromJSON,
    AddGroupEmergencyContactAuthIdsRequestToJSON,
    AddGroupEmergencyEmailRequestFromJSON,
    AddGroupEmergencyEmailRequestToJSON,
    GetAllOrgResponseFromJSON,
    GetAllOrgResponseToJSON,
    GroupEmergencyContactsOnAzureFromJSON,
    GroupEmergencyContactsOnAzureToJSON,
    MiniOrganizationFromJSON,
    MiniOrganizationToJSON,
    OrgEmergencyContactsOnAzureFromJSON,
    OrgEmergencyContactsOnAzureToJSON,
    OrgUserOnAzureFromJSON,
    OrgUserOnAzureToJSON,
    OrganizationAdminAddGroupFromJSON,
    OrganizationAdminAddGroupToJSON,
    OrganizationAdminMoveGroupMemberRequestFromJSON,
    OrganizationAdminMoveGroupMemberRequestToJSON,
    OrganizationAdminRemoveGroupFromJSON,
    OrganizationAdminRemoveGroupToJSON,
    OrganizationAdminUpdateFromJSON,
    OrganizationAdminUpdateToJSON,
    OrganizationAdminUpdateGroupLocationTrackingFromJSON,
    OrganizationAdminUpdateGroupLocationTrackingToJSON,
    OrganizationAdminUpdateGroupNameFromJSON,
    OrganizationAdminUpdateGroupNameToJSON,
    OrganizationOnAzureFromJSON,
    OrganizationOnAzureToJSON,
    OrganizationSalesCreateFromJSON,
    OrganizationSalesCreateToJSON,
    OrganizationSalesDeleteFromJSON,
    OrganizationSalesDeleteToJSON,
    OrganizationSalesRequestUpdateSubscriptionFromJSON,
    OrganizationSalesRequestUpdateSubscriptionToJSON,
    OrganizationSalesSeatReductionPreviewResponseFromJSON,
    OrganizationSalesSeatReductionPreviewResponseToJSON,
    OrganizationSalesUpdateFromJSON,
    OrganizationSalesUpdateToJSON,
    OrganizationSalesUpdateSubscriptionFromJSON,
    OrganizationSalesUpdateSubscriptionToJSON,
    RemoveEmergencyContactAuthIdsRequestFromJSON,
    RemoveEmergencyContactAuthIdsRequestToJSON,
    RemoveEmergencyEmailRequestFromJSON,
    RemoveEmergencyEmailRequestToJSON,
    RemoveGroupEmergencyContactAuthIdsRequestFromJSON,
    RemoveGroupEmergencyContactAuthIdsRequestToJSON,
    RemoveGroupEmergencyEmailRequestFromJSON,
    RemoveGroupEmergencyEmailRequestToJSON,
    SendTestEmailRequestFromJSON,
    SendTestEmailRequestToJSON,
    SetRequireJoinApprovalRequestFromJSON,
    SetRequireJoinApprovalRequestToJSON,
    SetRequireJoinApprovalResultFromJSON,
    SetRequireJoinApprovalResultToJSON,
    SetUserTierRequestFromJSON,
    SetUserTierRequestToJSON,
    UpdateEmergencyEmailLanguageRequestFromJSON,
    UpdateEmergencyEmailLanguageRequestToJSON,
    UpdateGroupEmergencyEmailLanguageRequestFromJSON,
    UpdateGroupEmergencyEmailLanguageRequestToJSON,
    UserCapabilitiesResponseFromJSON,
    UserCapabilitiesResponseToJSON,
    UserEmergencyContactResponseFromJSON,
    UserEmergencyContactResponseToJSON,
} from '../models/index';

export interface ApiOrganizationAddEmergencyContactAuthIdsPutRequest {
    addEmergencyContactAuthIdsRequest?: AddEmergencyContactAuthIdsRequest;
}

export interface ApiOrganizationAddEmergencyEmailViaAdminPutRequest {
    addEmergencyEmailRequest?: AddEmergencyEmailRequest;
}

export interface ApiOrganizationAddGroupEmergencyContactAuthIdsPutRequest {
    addGroupEmergencyContactAuthIdsRequest?: AddGroupEmergencyContactAuthIdsRequest;
}

export interface ApiOrganizationAddGroupEmergencyEmailPutRequest {
    addGroupEmergencyEmailRequest?: AddGroupEmergencyEmailRequest;
}

export interface ApiOrganizationAddGroupViaAdminPutRequest {
    organizationAdminAddGroup?: OrganizationAdminAddGroup;
}

export interface ApiOrganizationAddPostRequest {
    organizationSalesCreate?: OrganizationSalesCreate;
}

export interface ApiOrganizationDeleteDeleteRequest {
    organizationSalesDelete?: OrganizationSalesDelete;
}

export interface ApiOrganizationGetAllGroupEmergencyContactsGetRequest {
    orgCode?: string;
}

export interface ApiOrganizationGetByOrgCodeGetRequest {
    orgCode?: string;
}

export interface ApiOrganizationGetGroupEmergencyContactsGetRequest {
    groupId?: string;
}

export interface ApiOrganizationGetGroupMembersGetRequest {
    orgCode?: string;
    groupName?: string;
}

export interface ApiOrganizationGetGroupsGetRequest {
    orgCode?: string;
    joinOrgPin?: string;
}

export interface ApiOrganizationGetGroupsOpenGetRequest {
    orgCode?: string;
}

export interface ApiOrganizationGetIfRequiresPinGetRequest {
    orgCode?: string;
}

export interface ApiOrganizationGetMiniOrganizationGetRequest {
    orgCode?: string;
}

export interface ApiOrganizationMoveGroupMemberViaAdminPutRequest {
    organizationAdminMoveGroupMemberRequest?: OrganizationAdminMoveGroupMemberRequest;
}

export interface ApiOrganizationRemoveEmergencyContactAuthIdsDeleteRequest {
    removeEmergencyContactAuthIdsRequest?: RemoveEmergencyContactAuthIdsRequest;
}

export interface ApiOrganizationRemoveEmergencyEmailViaAdminDeleteRequest {
    removeEmergencyEmailRequest?: RemoveEmergencyEmailRequest;
}

export interface ApiOrganizationRemoveGroupEmergencyContactAuthIdsDeleteRequest {
    removeGroupEmergencyContactAuthIdsRequest?: RemoveGroupEmergencyContactAuthIdsRequest;
}

export interface ApiOrganizationRemoveGroupEmergencyEmailDeleteRequest {
    removeGroupEmergencyEmailRequest?: RemoveGroupEmergencyEmailRequest;
}

export interface ApiOrganizationRemoveGroupViaAdminPutRequest {
    organizationAdminRemoveGroup?: OrganizationAdminRemoveGroup;
}

export interface ApiOrganizationRequestUpdateSubscriptionViaSalesPutRequest {
    organizationSalesRequestUpdateSubscription?: OrganizationSalesRequestUpdateSubscription;
}

export interface ApiOrganizationSendTestEmailPostRequest {
    sendTestEmailRequest?: SendTestEmailRequest;
}

export interface ApiOrganizationSetRequireJoinApprovalPutRequest {
    setRequireJoinApprovalRequest?: SetRequireJoinApprovalRequest;
}

export interface ApiOrganizationSetUserTierPutRequest {
    setUserTierRequest?: SetUserTierRequest;
}

export interface ApiOrganizationToggleAddNewAdminsToEmergencyContactsPutRequest {
    enabled?: boolean;
}

export interface ApiOrganizationToggleAddNewMembersToEmergencyContactsPutRequest {
    groupId?: string;
    enabled?: boolean;
}

export interface ApiOrganizationUpdateEmergencyEmailLanguageViaAdminPutRequest {
    updateEmergencyEmailLanguageRequest?: UpdateEmergencyEmailLanguageRequest;
}

export interface ApiOrganizationUpdateGroupEmergencyEmailLanguagePutRequest {
    updateGroupEmergencyEmailLanguageRequest?: UpdateGroupEmergencyEmailLanguageRequest;
}

export interface ApiOrganizationUpdateGroupLocationTrackingViaAdminPutRequest {
    organizationAdminUpdateGroupLocationTracking?: OrganizationAdminUpdateGroupLocationTracking;
}

export interface ApiOrganizationUpdateGroupNameViaAdminPutRequest {
    organizationAdminUpdateGroupName?: OrganizationAdminUpdateGroupName;
}

export interface ApiOrganizationUpdateSubscriptionViaSalesPutRequest {
    organizationSalesUpdateSubscription?: OrganizationSalesUpdateSubscription;
}

export interface ApiOrganizationUpdateViaAdminPutRequest {
    organizationAdminUpdate?: OrganizationAdminUpdate;
}

export interface ApiOrganizationUpdateViaSalesPutRequest {
    organizationSalesUpdate?: OrganizationSalesUpdate;
}

/**
 * 
 */
export class OrganizationApi extends runtime.BaseAPI {

    /**
     */
    async apiOrganizationAddEmergencyContactAuthIdsPutRaw(requestParameters: ApiOrganizationAddEmergencyContactAuthIdsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/AddEmergencyContactAuthIds`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddEmergencyContactAuthIdsRequestToJSON(requestParameters['addEmergencyContactAuthIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationAddEmergencyContactAuthIdsPut(requestParameters: ApiOrganizationAddEmergencyContactAuthIdsPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationAddEmergencyContactAuthIdsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationAddEmergencyEmailViaAdminPutRaw(requestParameters: ApiOrganizationAddEmergencyEmailViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/AddEmergencyEmailViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddEmergencyEmailRequestToJSON(requestParameters['addEmergencyEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationAddEmergencyEmailViaAdminPut(requestParameters: ApiOrganizationAddEmergencyEmailViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationAddEmergencyEmailViaAdminPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationAddGroupEmergencyContactAuthIdsPutRaw(requestParameters: ApiOrganizationAddGroupEmergencyContactAuthIdsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/AddGroupEmergencyContactAuthIds`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddGroupEmergencyContactAuthIdsRequestToJSON(requestParameters['addGroupEmergencyContactAuthIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationAddGroupEmergencyContactAuthIdsPut(requestParameters: ApiOrganizationAddGroupEmergencyContactAuthIdsPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationAddGroupEmergencyContactAuthIdsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationAddGroupEmergencyEmailPutRaw(requestParameters: ApiOrganizationAddGroupEmergencyEmailPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/AddGroupEmergencyEmail`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AddGroupEmergencyEmailRequestToJSON(requestParameters['addGroupEmergencyEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationAddGroupEmergencyEmailPut(requestParameters: ApiOrganizationAddGroupEmergencyEmailPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationAddGroupEmergencyEmailPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationAddGroupViaAdminPutRaw(requestParameters: ApiOrganizationAddGroupViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/AddGroupViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAdminAddGroupToJSON(requestParameters['organizationAdminAddGroup']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationAddGroupViaAdminPut(requestParameters: ApiOrganizationAddGroupViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationAddGroupViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationAddPostRaw(requestParameters: ApiOrganizationAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationSalesCreateToJSON(requestParameters['organizationSalesCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationAddPost(requestParameters: ApiOrganizationAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationOnAzure> {
        const response = await this.apiOrganizationAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationDeleteDeleteRaw(requestParameters: ApiOrganizationDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationSalesDeleteToJSON(requestParameters['organizationSalesDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationDeleteDelete(requestParameters: ApiOrganizationDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GetAllOrgResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetAll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GetAllOrgResponseFromJSON));
    }

    /**
     */
    async apiOrganizationGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GetAllOrgResponse>> {
        const response = await this.apiOrganizationGetAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetAllGroupEmergencyContactsGetRaw(requestParameters: ApiOrganizationGetAllGroupEmergencyContactsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<GroupEmergencyContactsOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetAllGroupEmergencyContacts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(GroupEmergencyContactsOnAzureFromJSON));
    }

    /**
     */
    async apiOrganizationGetAllGroupEmergencyContactsGet(requestParameters: ApiOrganizationGetAllGroupEmergencyContactsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<GroupEmergencyContactsOnAzure>> {
        const response = await this.apiOrganizationGetAllGroupEmergencyContactsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetByOrgCodeGetRaw(requestParameters: ApiOrganizationGetByOrgCodeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetByOrgCode`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGetByOrgCodeGet(requestParameters: ApiOrganizationGetByOrgCodeGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationOnAzure> {
        const response = await this.apiOrganizationGetByOrgCodeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetGroupEmergencyContactsGetRaw(requestParameters: ApiOrganizationGetGroupEmergencyContactsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['groupId'] != null) {
            queryParameters['group_id'] = requestParameters['groupId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetGroupEmergencyContacts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGetGroupEmergencyContactsGet(requestParameters: ApiOrganizationGetGroupEmergencyContactsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationGetGroupEmergencyContactsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetGroupMembersGetRaw(requestParameters: ApiOrganizationGetGroupMembersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrgUserOnAzure>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        if (requestParameters['groupName'] != null) {
            queryParameters['group_name'] = requestParameters['groupName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetGroupMembers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrgUserOnAzureFromJSON));
    }

    /**
     */
    async apiOrganizationGetGroupMembersGet(requestParameters: ApiOrganizationGetGroupMembersGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrgUserOnAzure>> {
        const response = await this.apiOrganizationGetGroupMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetGroupsGetRaw(requestParameters: ApiOrganizationGetGroupsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        if (requestParameters['joinOrgPin'] != null) {
            queryParameters['join_org_pin'] = requestParameters['joinOrgPin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetGroups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiOrganizationGetGroupsGet(requestParameters: ApiOrganizationGetGroupsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.apiOrganizationGetGroupsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetGroupsOpenGetRaw(requestParameters: ApiOrganizationGetGroupsOpenGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetGroupsOpen`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async apiOrganizationGetGroupsOpenGet(requestParameters: ApiOrganizationGetGroupsOpenGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.apiOrganizationGetGroupsOpenGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetIfRequiresPinGetRaw(requestParameters: ApiOrganizationGetIfRequiresPinGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetIfRequiresPin`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiOrganizationGetIfRequiresPinGet(requestParameters: ApiOrganizationGetIfRequiresPinGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.apiOrganizationGetIfRequiresPinGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetMiniOrganizationGetRaw(requestParameters: ApiOrganizationGetMiniOrganizationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniOrganization>> {
        const queryParameters: any = {};

        if (requestParameters['orgCode'] != null) {
            queryParameters['org_code'] = requestParameters['orgCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetMiniOrganization`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MiniOrganizationFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGetMiniOrganizationGet(requestParameters: ApiOrganizationGetMiniOrganizationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniOrganization> {
        const response = await this.apiOrganizationGetMiniOrganizationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetOrgEmergencyContactsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetOrgEmergencyContacts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationGetOrgEmergencyContactsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationGetOrgEmergencyContactsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationGetUserEmergencyContactsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserEmergencyContactResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/GetUserEmergencyContacts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserEmergencyContactResponseFromJSON));
    }

    /**
     */
    async apiOrganizationGetUserEmergencyContactsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserEmergencyContactResponse>> {
        const response = await this.apiOrganizationGetUserEmergencyContactsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationMoveGroupMemberViaAdminPutRaw(requestParameters: ApiOrganizationMoveGroupMemberViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/MoveGroupMemberViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAdminMoveGroupMemberRequestToJSON(requestParameters['organizationAdminMoveGroupMemberRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationMoveGroupMemberViaAdminPut(requestParameters: ApiOrganizationMoveGroupMemberViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationMoveGroupMemberViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationRemoveEmergencyContactAuthIdsDeleteRaw(requestParameters: ApiOrganizationRemoveEmergencyContactAuthIdsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/RemoveEmergencyContactAuthIds`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveEmergencyContactAuthIdsRequestToJSON(requestParameters['removeEmergencyContactAuthIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationRemoveEmergencyContactAuthIdsDelete(requestParameters: ApiOrganizationRemoveEmergencyContactAuthIdsDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationRemoveEmergencyContactAuthIdsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationRemoveEmergencyEmailViaAdminDeleteRaw(requestParameters: ApiOrganizationRemoveEmergencyEmailViaAdminDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/RemoveEmergencyEmailViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveEmergencyEmailRequestToJSON(requestParameters['removeEmergencyEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationRemoveEmergencyEmailViaAdminDelete(requestParameters: ApiOrganizationRemoveEmergencyEmailViaAdminDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationRemoveEmergencyEmailViaAdminDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationRemoveGroupEmergencyContactAuthIdsDeleteRaw(requestParameters: ApiOrganizationRemoveGroupEmergencyContactAuthIdsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/RemoveGroupEmergencyContactAuthIds`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveGroupEmergencyContactAuthIdsRequestToJSON(requestParameters['removeGroupEmergencyContactAuthIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationRemoveGroupEmergencyContactAuthIdsDelete(requestParameters: ApiOrganizationRemoveGroupEmergencyContactAuthIdsDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationRemoveGroupEmergencyContactAuthIdsDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationRemoveGroupEmergencyEmailDeleteRaw(requestParameters: ApiOrganizationRemoveGroupEmergencyEmailDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/RemoveGroupEmergencyEmail`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: RemoveGroupEmergencyEmailRequestToJSON(requestParameters['removeGroupEmergencyEmailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationRemoveGroupEmergencyEmailDelete(requestParameters: ApiOrganizationRemoveGroupEmergencyEmailDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationRemoveGroupEmergencyEmailDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationRemoveGroupViaAdminPutRaw(requestParameters: ApiOrganizationRemoveGroupViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/RemoveGroupViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAdminRemoveGroupToJSON(requestParameters['organizationAdminRemoveGroup']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationRemoveGroupViaAdminPut(requestParameters: ApiOrganizationRemoveGroupViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationRemoveGroupViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationRequestUpdateSubscriptionViaSalesPutRaw(requestParameters: ApiOrganizationRequestUpdateSubscriptionViaSalesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationSalesSeatReductionPreviewResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/RequestUpdateSubscriptionViaSales`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationSalesRequestUpdateSubscriptionToJSON(requestParameters['organizationSalesRequestUpdateSubscription']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationSalesSeatReductionPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationRequestUpdateSubscriptionViaSalesPut(requestParameters: ApiOrganizationRequestUpdateSubscriptionViaSalesPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationSalesSeatReductionPreviewResponse> {
        const response = await this.apiOrganizationRequestUpdateSubscriptionViaSalesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationSendTestEmailPostRaw(requestParameters: ApiOrganizationSendTestEmailPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/SendTestEmail`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendTestEmailRequestToJSON(requestParameters['sendTestEmailRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationSendTestEmailPost(requestParameters: ApiOrganizationSendTestEmailPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationSendTestEmailPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationSetRequireJoinApprovalPutRaw(requestParameters: ApiOrganizationSetRequireJoinApprovalPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetRequireJoinApprovalResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/SetRequireJoinApproval`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetRequireJoinApprovalRequestToJSON(requestParameters['setRequireJoinApprovalRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetRequireJoinApprovalResultFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationSetRequireJoinApprovalPut(requestParameters: ApiOrganizationSetRequireJoinApprovalPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetRequireJoinApprovalResult> {
        const response = await this.apiOrganizationSetRequireJoinApprovalPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationSetUserTierPutRaw(requestParameters: ApiOrganizationSetUserTierPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MiniOrganization>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/SetUserTier`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetUserTierRequestToJSON(requestParameters['setUserTierRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MiniOrganizationFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationSetUserTierPut(requestParameters: ApiOrganizationSetUserTierPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MiniOrganization> {
        const response = await this.apiOrganizationSetUserTierPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationToggleAddNewAdminsToEmergencyContactsPutRaw(requestParameters: ApiOrganizationToggleAddNewAdminsToEmergencyContactsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/ToggleAddNewAdminsToEmergencyContacts`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationToggleAddNewAdminsToEmergencyContactsPut(requestParameters: ApiOrganizationToggleAddNewAdminsToEmergencyContactsPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationToggleAddNewAdminsToEmergencyContactsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationToggleAddNewMembersToEmergencyContactsPutRaw(requestParameters: ApiOrganizationToggleAddNewMembersToEmergencyContactsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        if (requestParameters['groupId'] != null) {
            queryParameters['group_id'] = requestParameters['groupId'];
        }

        if (requestParameters['enabled'] != null) {
            queryParameters['enabled'] = requestParameters['enabled'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/ToggleAddNewMembersToEmergencyContacts`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationToggleAddNewMembersToEmergencyContactsPut(requestParameters: ApiOrganizationToggleAddNewMembersToEmergencyContactsPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationToggleAddNewMembersToEmergencyContactsPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationUpdateEmergencyEmailLanguageViaAdminPutRaw(requestParameters: ApiOrganizationUpdateEmergencyEmailLanguageViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateEmergencyEmailLanguageViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEmergencyEmailLanguageRequestToJSON(requestParameters['updateEmergencyEmailLanguageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationUpdateEmergencyEmailLanguageViaAdminPut(requestParameters: ApiOrganizationUpdateEmergencyEmailLanguageViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationUpdateEmergencyEmailLanguageViaAdminPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationUpdateGroupEmergencyEmailLanguagePutRaw(requestParameters: ApiOrganizationUpdateGroupEmergencyEmailLanguagePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupEmergencyContactsOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateGroupEmergencyEmailLanguage`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateGroupEmergencyEmailLanguageRequestToJSON(requestParameters['updateGroupEmergencyEmailLanguageRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupEmergencyContactsOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationUpdateGroupEmergencyEmailLanguagePut(requestParameters: ApiOrganizationUpdateGroupEmergencyEmailLanguagePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupEmergencyContactsOnAzure> {
        const response = await this.apiOrganizationUpdateGroupEmergencyEmailLanguagePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationUpdateGroupLocationTrackingViaAdminPutRaw(requestParameters: ApiOrganizationUpdateGroupLocationTrackingViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateGroupLocationTrackingViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAdminUpdateGroupLocationTrackingToJSON(requestParameters['organizationAdminUpdateGroupLocationTracking']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationUpdateGroupLocationTrackingViaAdminPut(requestParameters: ApiOrganizationUpdateGroupLocationTrackingViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationUpdateGroupLocationTrackingViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationUpdateGroupNameViaAdminPutRaw(requestParameters: ApiOrganizationUpdateGroupNameViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateGroupNameViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAdminUpdateGroupNameToJSON(requestParameters['organizationAdminUpdateGroupName']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationUpdateGroupNameViaAdminPut(requestParameters: ApiOrganizationUpdateGroupNameViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationUpdateGroupNameViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationUpdateSubscriptionViaSalesPutRaw(requestParameters: ApiOrganizationUpdateSubscriptionViaSalesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationSalesSeatReductionPreviewResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateSubscriptionViaSales`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationSalesUpdateSubscriptionToJSON(requestParameters['organizationSalesUpdateSubscription']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationSalesSeatReductionPreviewResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationUpdateSubscriptionViaSalesPut(requestParameters: ApiOrganizationUpdateSubscriptionViaSalesPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationSalesSeatReductionPreviewResponse> {
        const response = await this.apiOrganizationUpdateSubscriptionViaSalesPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiOrganizationUpdateViaAdminPutRaw(requestParameters: ApiOrganizationUpdateViaAdminPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateViaAdmin`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationAdminUpdateToJSON(requestParameters['organizationAdminUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationUpdateViaAdminPut(requestParameters: ApiOrganizationUpdateViaAdminPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationUpdateViaAdminPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationUpdateViaSalesPutRaw(requestParameters: ApiOrganizationUpdateViaSalesPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UpdateViaSales`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationSalesUpdateToJSON(requestParameters['organizationSalesUpdate']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiOrganizationUpdateViaSalesPut(requestParameters: ApiOrganizationUpdateViaSalesPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiOrganizationUpdateViaSalesPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiOrganizationUserCapabilitiesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserCapabilitiesResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Organization/UserCapabilities`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserCapabilitiesResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiOrganizationUserCapabilitiesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserCapabilitiesResponse> {
        const response = await this.apiOrganizationUserCapabilitiesGetRaw(initOverrides);
        return await response.value();
    }

}
